var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLinkedin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 5C3.5 3.89543 4.39543 3 5.5 3C6.03043 3 6.53914 3.21071 6.91421 3.58579C7.28929 3.96086 7.5 4.46957 7.5 5C7.5 6.10457 6.60457 7 5.5 7C4.39543 7 3.5 6.10457 3.5 5ZM21 13.41C21.0345 11.2449 19.5574 9.34762 17.45 8.85C16.0377 8.5459 14.5657 8.94467 13.5 9.92V9.5C13.5 9.22386 13.2761 9 13 9H10.5C10.2239 9 10 9.22386 10 9.5V19.5C10 19.7761 10.2239 20 10.5 20H13C13.2761 20 13.5 19.7761 13.5 19.5V13.86C13.4753 12.8557 14.1753 11.9787 15.16 11.78C15.7464 11.6788 16.3473 11.8439 16.7997 12.2305C17.252 12.6171 17.5087 13.185 17.5 13.78V19.5C17.5 19.7761 17.7239 20 18 20H20.5C20.7761 20 21 19.7761 21 19.5V13.41ZM7.5 9.5V19.5C7.5 19.7761 7.27614 20 7 20H4.5C4.22386 20 4 19.7761 4 19.5V9.5C4 9.22386 4.22386 9 4.5 9H7C7.27614 9 7.5 9.22386 7.5 9.5Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedin.6ff3d133.svg";
export { ForwardRef as ReactComponent };